import React, {useCallback} from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import Tab from '../../../../../elements/Tabs/Tab';
import {isFavoriteParticipantsFilterTabActive} from './isFavoriteParticipantsFilterTabActive';
import {useDispatch} from 'react-redux';

const FAVORITES_FILTER = {
    favorites: true,
};

function FavoriteParticipants(props) {
    const {className = '', eventId, filterParams} = props,
        i18n = useI18n(),
        selected = isFavoriteParticipantsFilterTabActive(filterParams),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, FAVORITES_FILTER));
    }, [eventId]);

    return (
        <Tab className={className} selected={selected} onClick={handleClick}>
            {i18n['label.tab.favorites']}
        </Tab>
    );
}

export default FavoriteParticipants;
